/**
 * @generated SignedSource<<c60317ee44a78312135b512d4a4b388e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type importResultsPage_MultiUploadQuery$variables = {
  id: string;
};
export type importResultsPage_MultiUploadQuery$data = {
  readonly multiUpload: {
    readonly id: string;
    readonly state: string;
    readonly uploads: ReadonlyArray<{
      readonly accountSlug: string | null | undefined;
      readonly duplicate: boolean;
      readonly filename: string | null | undefined;
      readonly id: string;
      readonly notice: string | null | undefined;
      readonly providerKey: string | null | undefined;
      readonly rowsCount: number;
      readonly state: string;
    }>;
  } | null | undefined;
};
export type importResultsPage_MultiUploadQuery = {
  response: importResultsPage_MultiUploadQuery$data;
  variables: importResultsPage_MultiUploadQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "MultiUpload",
    "kind": "LinkedField",
    "name": "multiUpload",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      (v2/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Upload",
        "kind": "LinkedField",
        "name": "uploads",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "filename",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "providerKey",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountSlug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rowsCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "duplicate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "notice",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "importResultsPage_MultiUploadQuery",
    "selections": (v3/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "importResultsPage_MultiUploadQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "2b23ed1417b0e2e10ad56f4beda6ace6",
    "id": null,
    "metadata": {},
    "name": "importResultsPage_MultiUploadQuery",
    "operationKind": "query",
    "text": "query importResultsPage_MultiUploadQuery(\n  $id: ID!\n) {\n  multiUpload(id: $id) {\n    id\n    state\n    uploads {\n      id\n      state\n      filename\n      providerKey\n      accountSlug\n      rowsCount\n      duplicate\n      notice\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "48c8a116bea831b1c5f734cf76ae668d";

export default node;
